module.exports = __webpack_public_path__ + "static/s3-2-biodegradables-d-608ac7a30f3a05a624373e5e91617dd9.jpg";